// AUTHOR: GOPALAKRISHNAN
// VERSION: 0.0.1
// LAST EDIT: GOPALAKRISHNAN
// DATE: 05/01/2026
// DESCRIPTION: DEALER REPORT PAGE REDUCER
/* eslint-disable import/no-anonymous-default-export */
import { docodeHexResponse } from '../../_common/common.utils';
import DealerReportActionTypes from './dealer-report.types';
const INITIAL_STATE = {
	fetchDealerReportResponse: null,
	fetchDealerReportArr: [],
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** GET DEALER REPORT DETAILS START *********************** */
		case DealerReportActionTypes.FETCH_DEALER_REPORT_SUCCESS:
			return {
				...state,
				fetchDealerReportResponse: action.payload,
				fetchDealerReportArr: docodeHexResponse(action.payload, 'DealerReportKey'),
			};

		case DealerReportActionTypes.FETCH_DEALER_REPORT_FAILURE:
			return { ...state, fetchDealerReportResponse: action.payload };

		case DealerReportActionTypes.FETCH_DEALER_REPORT_RESPONSE_CHANGED:
			return {
				...state,
				fetchDealerReportResponse: null,
			};
		/** ***************** GET DEALER REPORT DETAILS END *********************** */

		default:
			return state;
	}
};
